:global(.MenuItem).item {
  --color-skeleton-background: #2121211a;

  pointer-events: none;
  cursor: var(--custom-cursor, default);

  margin-bottom: 0;

  font-size: 0.8125rem;
  font-weight: var(--font-weight-normal);
  &:hover,
  &:focus,
  &:active {
    background: none;
  }

  :global(.icon) {
    margin-inline-end: 0.25rem;
  }
}

.timer {
  margin-inline-start: 0.25rem;
}

.get {
  pointer-events: all;
  cursor: var(--custom-cursor, pointer);

  margin-inline-start: 0.375rem;
  padding: 0.1875rem 0.375rem;
  border-radius: 1rem;

  font-size: 0.6875rem;
  font-weight: var(--font-weight-medium);

  background: var(--color-background-menu-separator);
  filter: opacity(0.8);

  transition: 150ms filter ease-in;

  &:hover {
    filter: brightness(1.1);
  }
}

.skeleton {
  width: calc(100% - 2rem);
  height: 0.5rem;
  margin: 0.5rem 0;
  border-radius: 0.25rem;
}

.transition {
  width: auto;
  height: 1.5rem;
}
